import { createFormSnippetGroup } from '@ipfabric/ui-components/utils/formSnippets/FormSnippetGroup';
import { SearchableSection } from '../../../components/DiscoverySearch/SearchableSection';
import { manualDeviceLinks } from '../../../snippets/manualDeviceLinks';
import type { DiscoverySettingsGroupDisplayControl } from '../DiscoverySettings';

export const manualDeviceLinksGroup = createFormSnippetGroup({
  snippets: {
    manualDeviceLinks,
  },
  render: ({ renderSnippet }) => (
    <div className='flex-1 flex flex-col gap'>
      <div className='text-default text-level-4 font-semibold font-heading'>
        Manual device links
      </div>
      <div className='flex-1 flex flex-col rounded-lg bg-default'>
        <SearchableSection
          id='manual-device-links'
          searchTerms={['Link list']}
          highlightOn={['manualDeviceLinks']}
          className='flex-1 flex flex-col'
          wrapperClassName='flex-1 flex flex-col'
        >
          {renderSnippet('manualDeviceLinks')}
        </SearchableSection>
      </div>
    </div>
  ),
  show: (control: DiscoverySettingsGroupDisplayControl) => {
    control.setTab('manualDeviceLinks');
  },
});
